export default __webpack_public_path__ + "static/curvas_nivel-f8ca2c55c1e01ab9b5ec8b43f4716fd5.png";